document.addEventListener('DOMContentLoaded', () => {
    let isInTheCart = false;
    let difference = 1;
  
    function checkItemQty() {
        const productSelect = document.getElementById('product-select');
        if(productSelect){
          const selectedOption = productSelect.options[productSelect.selectedIndex];
          if (selectedOption) {
          const selectedValue = selectedOption.value;
          const itemQty = parseInt(selectedOption.getAttribute('item-qty'));
  
          const cartItems = document.querySelectorAll('.cart-drawer-item');
          isInTheCart = false;  // Reset the flag for each check
  
          cartItems.forEach(item => {
              const itemId = item.getAttribute('item-id');
              const cartItemQty = parseInt(item.getAttribute('item-qty'));
  
              if (itemId === selectedValue) {
                  isInTheCart = true;
                  console.log(`Item ID: ${itemId}, Selected Item Stock: ${itemQty} -- Cart item quantity: ${cartItemQty}`);
                   difference = itemQty - cartItemQty;
                  console.log(`Difference: ${difference}`);
              }
          });
  
          if (!isInTheCart) {
              console.log('Selected item is not in the cart.');
          }
        }
        }
    }

  function DisplayAddingAnimation(action, text) {
    const addToCartButton = document.querySelector('.product__atc-btn');
    if (addToCartButton) {
      addToCartButton.querySelector('span[data-add-to-cart-text]').textContent = text;
    }
    const spinner = document.querySelector('.product__btn-container .spinner');
    if (spinner) {
      spinner.style.display = action;
    }
}

    // Checked selected variant and cart items
    document.getElementById('product-select')?.addEventListener('change', checkItemQty);

    document.getElementById('addToBagButton')?.addEventListener('click', function(event) {
       event.preventDefault();
      let addToBagButton = document.getElementById('addToBagButton');
      if (addToBagButton.getAttribute('product-status') === 'Sold Out') {
          // Do nothing if the item is sold out
          console.log('sold out item');
      }else{
        // Prevent the default action
       
       DisplayAddingAnimation('block','Adding...');
        difference =1;

        // Trigger the selection function to check the item qty
        checkItemQty();

        let is_giftcard = false;

        if (document.body.classList.contains('product-giftcard')) {
            is_giftcard = true;
        }

        if (difference > 0 || is_giftcard == true ) {
            // Perform your custom action
            console.log("Custom action executed");
            
           const form = addToBagButton.closest('form[action="/cart/add"]');
            if (form) {
                const submitEvent = new Event('submit', { bubbles: true, cancelable: true });
                form.dispatchEvent(submitEvent);
            }
            
        } else {
            console.log("Custom action not executed, default action prevented");
            alert('you already have our last stock of that variant in your cart!');
           DisplayAddingAnimation('none','Add to Bag');
        }
      }
    });
});
